import { push } from 'react-router-redux';
import SubmissionError from 'redux-form/lib/SubmissionError';
import { submitCreateEpisodeFormEvent } from './partnerAnalytics';

export const FETCHING_EPISODES = '@@episodes/FETCHING_EPISODES';
export const RECEIVE_EPISODES = '@@episodes/RECEIVE_EPISODES';
export const SET_IS_CREATING = '@@episodes/SET_IS_CREATING';
export const SET_IS_RENAMING = '@@episodes/SET_IS_RENAMING';

const emptyArray = [];
const emptyObject = {};

const initialState = {
  episodes: emptyArray,
  isFetching: false,
  isCreating: false,
};

// reducer
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case FETCHING_EPISODES: {
      const { isFetching } = action;
      return {
        ...state,
        isFetching,
      };
    }
    case RECEIVE_EPISODES:
      return {
        ...state,
        episodes: action.episodes,
      };
    case SET_IS_RENAMING:
      return {
        ...state,
        isRenaming: action.isRenaming,
      };
    case SET_IS_CREATING:
      return {
        ...state,
        isCreating: action.isCreating,
      };
    default:
      return state;
  }
}

// action creators
function receiveEpisodes(episodes) {
  return {
    type: RECEIVE_EPISODES,
    episodes,
  };
}

function fetchingEpisodes(isFetching) {
  return {
    type: FETCHING_EPISODES,
    isFetching,
  };
}

export function setIsCreating(isCreating) {
  return {
    type: SET_IS_CREATING,
    isCreating,
  };
}

// thunks

export function fetchEpisodes() {
  return (dispatch, getState) => {
    dispatch(fetchingEpisodes(true));
    return fetch('/api/user/episodes', {
      credentials: 'same-origin',
    })
      .then(response => {
        if (response.status === 200) {
          return response.json();
        }
        return response;
      })
      .then(responseJson => {
        if (responseJson.status && responseJson.status !== 200) {
          if (responseJson.status === 401) {
            // not logged in
            return dispatch(push('/login'));
          }
          // e.g. no permissions (403)
          return dispatch(push('/404'));
        }
        const { episodes } = responseJson;
        return dispatch(receiveEpisodes(episodes));
      })
      .then(always, always);

    function always() {
      dispatch(fetchingEpisodes(false));
    }
  };
}

export function submitCreateEpisodeForm(data) {
  return (dispatch, getState) => {
    dispatch(submitCreateEpisodeFormEvent());
    return fetch('/api/user/episodes/', {
      method: 'POST',
      credentials: 'same-origin',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      body: JSON.stringify(data),
    })
      .then(response => {
        if (response.status === 200) {
          return response.json();
        }
        return response;
      })
      .then(responseJson => {
        const { status } = responseJson;
        if (status === 400) {
          throw new SubmissionError({
            _error: 'There was a problem with this title.',
          });
        }
        // e.g. no permissions (403)
        if (status === 403) {
          dispatch(push('/404'));
          return;
        }
        if (status === 401) {
          dispatch(push('/login'));
          return;
        }
        if (responseJson.episodeId) {
          dispatch(push(`/partner/episodes/${responseJson.episodeId}`));
        }
      })
      .then(always, always);

    function always() {
      dispatch(setIsCreating(false));
    }
  };
}
